export enum BillingRoutes {
  root = 'billing',
  overview = 'overview',
  upgrade = 'upgrade',
}
